import React from 'react';
import Button from '../../../../components/atoms/Button/Button';
import ButtonGroup from '@mui/material/ButtonGroup';


export type TabType = 'detail' | 'history' | 'error';

type Props = {
    active: TabType
    onChange: (t: TabType) => void
}

const Tabs: React.FC<Props> = ({active, onChange}) => (
        <ButtonGroup variant='outlined' color={'primary'} disableElevation disableRipple>
            <Button variant={active === 'detail' ? 'contained' : 'outlined'}
                    disableElevation
                    disableRipple
                    onClick={() => onChange('detail')}>Details</Button>
            <Button variant={active === 'history' ? 'contained' : 'outlined'}
                    disableElevation
                    disableRipple
                    onClick={() => onChange('history')}>History</Button>
            <Button variant={active === 'error' ? 'contained' : 'outlined'}
                    disableElevation
                    disableRipple
                    onClick={() => onChange('error')}>Errors</Button>
        </ButtonGroup>
    )

export default Tabs;
